/**
 * Created by zj on 2018/1/2.
 */
import Component from "../../../../lib/component";
import template from './autoSelectedItem.html';
import './autoSelectedItem.scss';

let config = {
    template: template,
    data: {
        id: '',
        name: '',
        py: '',
        checked: false,
        setColor: '#00AFEA',
        isSetColor: false,
    },
    binds: [
        {
            event: 'click',
            selector: '.match-visible',
            callback: function () {
                // let el = this.el.find('input:checkbox:checked');
                // console.log(el);
            }
        },
    ],
    actions: {
    },
    afterRender: function() {
        this.el.find('.my-select-span').attr('title', this.data.name);
        this.el.find('.set-color').css('background-color', this.data.setColor);
    }
};

let AutoSelectedItem = Component.extend(config);

export default AutoSelectedItem;


// WEBPACK FOOTER //
// app/components/util/autoSelect/autoSelectedItem/autoSelectedItem.js